import { UserStatus } from "@/types/user";
import { withBasePath } from "@/utils/basePath";

import { SelectedStatusType } from "./types";

export const StatusOptions: SelectedStatusType[] = [
  { label: "All", value: "all" },
  { label: "Active", value: UserStatus.ACTIVE },
  { label: "Inactive", value: UserStatus.INACTIVE },
  { label: "Not Verified", value: UserStatus.NOT_VERIFIED }
];

export const BADGE_LABEL_STATUS_MAP: { [K: string]: string } = {
  [UserStatus.ACTIVE]: "Active",
  [UserStatus.INACTIVE]: "Inactive",
  [UserStatus.NOT_VERIFIED]: "Not Verified"
};

export const BADGE_VARIANT_STATUS_MAP: { [K: string]: string } = {
  [UserStatus.ACTIVE]: "success",
  [UserStatus.INACTIVE]: "disabled",
  [UserStatus.NOT_VERIFIED]: "warning"
};

export const USER_MANAGEMENT_BREADCRUMB_CONFIG = [
  {
    label: "Settings",
    path: withBasePath("user-management")
  },
  {
    label: "Users"
  }
];

export const USER_MANAGEMENT_NO_DATA_MESSAGE_MAPPING = {
  "no-data": {
    title: "No Users Yet",
    description: (
      <>
        You haven't added a users yet, click "<strong>Create User</strong>" to
        add new user and continue.
      </>
    )
  },
  "no-result": {
    title: "No Results Found",
    description:
      "Sorry, we couldn't find any matches from your keyword. Try using different or more general terms"
  }
};
